import { useAuth } from '@/hooks/useAuth.ts';
import PsiTrainingPage from '@/pages/training/PsiTrainingPage.tsx';
import InvestorTrainingPage from '@/pages/training/InvestorTrainingPage.tsx';

export default function TrainingPage() {
  const { user } = useAuth();
  return user?.role === 'psi' ? <PsiTrainingPage /> : <InvestorTrainingPage />;
}
